import React, { useContext, useRef, useState } from "react";
import { getWidgetSpecificIsVisible, executeActions } from "@utils/index";
import { connect } from "react-redux";
import { useOnload } from "@utils/useOnLoad";
import {
  Container,
  InnerContainer,
  Heading,
  HeadingText,
  HighlightedText,
  ScrollableContainer,
  CardsWrapper,
  ButtonContainer,
  ConfirmButton,
  CardContainer,
  CardHeader,
  CardUserInfoWrapper,
  CardUserInfo,
  CardUserAction,
  PriceSection,
  PriceWrapper,
  PriceLabel,
  PriceValue,
  SavingsTag,
  DealerPriceSection,
  DealerPriceLabel,
  DealerPriceValue,
  CardImageWrapper,
  NavigationControls,
  NavigationButton,
  UserAvatar
} from "./styles";
import { Context } from "@components/useContext/context";
import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import { fetchConfigAndRedirect } from "@actions/fetchConfigRedirect";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const LandingPageSrollableCardsWithHeading = (props: any) => {
  const {
    is_visible,
    testimonials,
    primaryButtonText = "Check price for your car",
    secondaryButtonText = "See the price list of all cars",
    headingText,
    highLightedText,
    actions
  } = props;
  const { on_load, primaryButtonOnClick, secondaryButtonOnClick } =
    actions || {};
  const { isDesktop } = useContext(Context);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [currentScrollIndex, setCurrentScrollIndex] = useState(0);
  useOnload({ on_load });

  // Calculate card width including gap (card width + gap)
  const getCardWidth = () => {
    if (isDesktop) {
      return 411 + 12; // Desktop card width + gap
    }
    return 235 + 12; // Mobile card width + gap
  };

  const scrollToCard = (index: number) => {
    if (scrollContainerRef.current) {
      const cardWidth = getCardWidth();
      const scrollPosition = index * cardWidth;
      scrollContainerRef.current.scrollTo({
        left: scrollPosition,
        behavior: "smooth"
      });
      setCurrentScrollIndex(index);
    }
  };

  const handleRightClick = () => {
    if (currentScrollIndex > 0) {
      scrollToCard(currentScrollIndex - 1);
    }
  };

  const handleLeftClick = () => {
    const totalCards = 5; // Based on the current Card components
    if (currentScrollIndex < totalCards - 1) {
      scrollToCard(currentScrollIndex + 1);
    }
  };

  const handlePrimaryButtonClick = () => {
    executeActions(primaryButtonOnClick);
  };
  const handleSecondaryButtonClick = () => {
    executeActions(secondaryButtonOnClick);
  };

  return (
    <Container>
      <InnerContainer>
        <Heading>
          <HeadingText> {headingText} </HeadingText>
          <HighlightedText> {highLightedText} </HighlightedText>
          {isDesktop && (
            <ButtonContainer>
              <ConfirmButton
                padding="13px 30px"
                width={100}
                disable={true}
                styles={{
                  margin: "32px 0 20px 0"
                }}
                onClick={handlePrimaryButtonClick}
              >
                {primaryButtonText}
              </ConfirmButton>
              <ConfirmButton
                padding="13px 30px"
                width={100}
                disable={false}
                styles={{
                  margin: "20px 0",
                  display: "none"
                }}
                onClick={handleSecondaryButtonClick}
              >
                {secondaryButtonText}
              </ConfirmButton>
              <NavigationControls>
                <NavigationButton onClick={handleRightClick}>
                  <ImageContainer
                    imgSrc={resolvePath("/images/arrow-right.svg")}
                    alt="arrow-right"
                    width={24}
                    height={24}
                    // isResolvePath={true}
                  />
                </NavigationButton>
                <NavigationButton rotate onClick={handleLeftClick}>
                  <ImageContainer
                    imgSrc={resolvePath("/images/arrow-right.svg")}
                    alt="arrow-left"
                    width={24}
                    height={24}
                    // isResolvePath={true}
                  />
                </NavigationButton>
              </NavigationControls>
            </ButtonContainer>
          )}
        </Heading>
        <ScrollableContainer
          ref={scrollContainerRef}
          className="hide-scrollbar"
        >
          <CardsWrapper>
            {testimonials?.map((testimonial: any) => (
              <Card key={testimonial?.id} testimonial={testimonial} />
            ))}
          </CardsWrapper>
        </ScrollableContainer>
        {!isDesktop && (
          <ButtonContainer>
            <ConfirmButton
              padding="13px 32px"
              width={isDesktop ? "320px" : "100%"}
              disable={true}
              styles={{ margin: "20px 0" }}
              onClick={handlePrimaryButtonClick}
            >
              {primaryButtonText}
            </ConfirmButton>
            <ConfirmButton
              padding="13px 32px"
              width={isDesktop ? "320px" : "100%"}
              disable={false}
              styles={{
                margin: "20px 0",
                display: "none"
              }}
              onClick={handleSecondaryButtonClick}
            >
              {secondaryButtonText}
            </ConfirmButton>
          </ButtonContainer>
        )}
      </InnerContainer>
    </Container>
  );
};

const Card = (props: any) => {
  const { testimonial } = props;
  const {
    headerImageUrl,
    headerPrefix,
    headerSuffix,
    id,
    makeId,
    modelId,
    rightFooterImage,
    savedBannerText,
    subHeader,
    textElement1,
    textElement2,
    textElement3,
    textElement4
  } = testimonial;
  const { isDesktop } = useContext(Context);
  const handleCardClick = () => {
    const currentYear = new Date().getFullYear();
    fetchConfigAndRedirect({
      requestBody: {
        current_node: "landing_page_node"
      },
      data: {
        ...(makeId && { make_id: parseInt(makeId) }),
        ...(modelId && { model_id: parseInt(modelId) }),
        registration_year: currentYear,
        manufacturing_year: currentYear,
        is_commercial: false
      },
      shouldRedirect: true,
      isRouterReplace: false,
      showCustomBasicLoader: true,
      showCustomLottie: false
    });
  };
  return (
    <CardContainer onClick={handleCardClick}>
      <CardHeader>
        <UserAvatar>
          <ImageContainer
            // imgSrc={resolvePath("/images/thumbs-up-icon.svg")}
            imgSrc={headerImageUrl}
            alt="user avatar"
            width={isDesktop ? 40 : 37}
            height={isDesktop ? 40 : 37}
          />
        </UserAvatar>
        <CardUserInfoWrapper>
          <CardUserInfo>
            {headerPrefix} • {headerSuffix}
          </CardUserInfo>
          <CardUserAction>{subHeader}</CardUserAction>
        </CardUserInfoWrapper>
      </CardHeader>

      <PriceSection>
        <PriceWrapper>
          <PriceLabel>{textElement1}:</PriceLabel>
          <PriceValue>{textElement2}</PriceValue>
        </PriceWrapper>
        <SavingsTag>{savedBannerText}</SavingsTag>
      </PriceSection>

      <DealerPriceSection>
        <DealerPriceLabel>{textElement3}: </DealerPriceLabel>
        <DealerPriceValue>{textElement4}</DealerPriceValue>
      </DealerPriceSection>

      <CardImageWrapper>
        <ImageContainer
          // imgSrc="https://ackodrive-prod.ackoassets.com/image/hyundai/grand-i10-nios/default/Hero-Transparent.png"
          imgSrc={rightFooterImage}
          alt="car"
          width={isDesktop ? 324 : 180}
          height={isDesktop ? 180 : 100}
          styles={{
            position: "absolute"
          }}
        />
      </CardImageWrapper>
    </CardContainer>
  );
};

export default connect(mapStateToProps)(LandingPageSrollableCardsWithHeading);
